export default {
    product_banners: {
        name: '',
        fields: {
            image_desktop: 'รูป (Desktop)',
            image_mobile: 'รูป (Mobile)',
            create: {title: 'สร้าง Product Banner'}
        }
    }
}